/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPEMPLOYMENTSTATUS = {
    SelfEmployed: 'S',
    Unemployed: 'U',
    Student: 'T',
    HomeExecutive: 'H',
    MinorOrScholar: 'M',
    Retired: 'RT',
    SalariedEmployee: 'SLE',
    SelfEmployedProfessional: 'SPR',
    Farmer: 'F',
    SalariedProfessional: 'SP'
} as const;
export type IAPEMPLOYMENTSTATUS = typeof IAPEMPLOYMENTSTATUS[keyof typeof IAPEMPLOYMENTSTATUS];


export function IAPEMPLOYMENTSTATUSFromJSON(json: any): IAPEMPLOYMENTSTATUS {
    return IAPEMPLOYMENTSTATUSFromJSONTyped(json, false);
}

export function IAPEMPLOYMENTSTATUSFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPEMPLOYMENTSTATUS {
    return json as IAPEMPLOYMENTSTATUS;
}

export function IAPEMPLOYMENTSTATUSToJSON(value?: IAPEMPLOYMENTSTATUS | null): any {
    return value as any;
}

